import { createFileRoute } from '@tanstack/react-router';

import { TailoredSupplyEditorPage } from '../features/campaigns/supply/components/TailoredSupplyEditorPage';

export const Route = createFileRoute('/campaigns/supply/tailored-supply/create')({
  component: TailoredSupplyEditorPage,
});
